import { BRAND } from "@/config/clinicConfig";

const LINKS = [
  { href: "#about", label: "About Us" },
  { href: "#results", label: "Gallery" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 bg-espresso shadow-[0_1px_0_rgba(212,175,55,0.28)]"
    >
      <nav className="mx-auto grid max-w-7xl grid-cols-[1fr_auto_1fr] items-center gap-4 px-5 py-3 lg:px-8">
        <a href="#top" data-testid="navbar-logo-link" className="justify-self-start flex items-center">
          <img
            src="/logo-gold.png"
            alt="Beauté Solutions — Cosmetic Esthetics"
            className="h-9 w-auto sm:h-11"
          />
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="relative text-sm font-medium text-cream/85 transition-colors duration-300 hover:text-gold after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-gold after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center justify-end gap-2.5">
          <a
            data-testid="top-store-link"
            href="https://www.janeiredaleshop.com"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full border border-gold/60 px-3 py-1.5 text-[11px] font-semibold text-gold transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-espresso sm:px-4 sm:text-[13px]"
          >
            Store
          </a>
          <a
            data-testid="top-consult-link"
            href={BRAND.consultUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-gold px-3 py-1.5 text-[11px] font-semibold text-espresso transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-cream sm:px-4 sm:text-[13px]"
          >
            Free photo consultation
          </a>
          <a
            data-testid="top-booking-link"
            href={BRAND.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-gold px-3 py-1.5 text-[11px] font-semibold text-espresso transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-cream sm:px-4 sm:text-[13px]"
          >
            Book Now
          </a>
        </div>
      </nav>
    </header>
  );
}
